/* eslint object-curly-newline: */
import { connect } from 'react-redux';
import LineChartComponent from './../Components/LineChartComponent.jsx';
import {
  getReleaseMetricsScanMetrics,
  releaseMetricsPageReducer
} from './../reducers';
import { colours, chart } from './../helpers';

export const mapStateToProps = (state) => {
  const info = releaseMetricsPageReducer.getReleaseMetricsInfo(state);
  const metrics = getReleaseMetricsScanMetrics(state);
  const ccfData = metrics.map(m => m && m.ccf.hitCount ? m.ccf.hitCount : null);
  const ncfData = metrics.map(m => m && m.ncf.hitCount ? m.ncf.hitCount : null);
  const pointRadius = metrics ? 0 : 4;

  return {
    data: [ccfData, ncfData],
    series: [
      {
        backgroundColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.CCF_DEFAULT,
        label: 'CCF Hit Count',
        pointRadius
      },
      {
        backgroundColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        borderColor: colours.METRICS_CHARTS.NCF_DEFAULT,
        label: 'NCF Hit Count',
        pointRadius,
        borderWidth: 1
      }
    ],
    labels: metrics.map(m => m.productVersion),
    options: {
      scales: { xAxes: [{ offset: true }] },
      tooltips: {
        callbacks: {
          title: (tooltipItem) =>
            chart.releaseMetricsVersionTooltipTitle(tooltipItem)(info, metrics),
          footer: (tooltipItem) => chart.metricsJobIdTooltipFooter(tooltipItem)(metrics)
        }
      }
    }
  };
};

export default connect(
  mapStateToProps
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/ReleaseMetricsHitCountChartContainer.jsx